import { Link } from 'react-router-dom';

const highlights = [
  {
    icon: 'ri-layout-grid-line',
    title: '多领域分类',
    text: '新闻、视频、购物、社交等热门领域清晰归类。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '一键直达',
    text: '点击即跳转目标网站外链，省去反复搜索的麻烦。',
  },
  {
    icon: 'ri-star-line',
    title: '精选推荐',
    text: '按热度与时间整理榜单，并推出场景化主题专题。',
  },
];

export default function IntroSection() {
  return (
    <section className="mt-10 overflow-hidden rounded-xl border border-background-200 bg-background-100">
      <div className="grid grid-cols-1 items-center gap-8 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            关于蓝导航
          </span>
          <h2 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            更懂你的综合导航平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            蓝导航面向广大互联网用户，致力于解决「快速找到目标网站入口」这一高频需求。我们把分散在各处的优质网站按领域整理成清晰的分类，让你无需记住复杂网址，也能高效抵达想去的网站。
          </p>

          <ul className="mt-6 flex flex-col gap-4">
            {highlights.map((item) => (
              <li key={item.title} className="flex items-start gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background-50 text-lg text-primary-600">
                  <i className={item.icon}></i>
                </span>
                <span>
                  <span className="block font-heading text-sm font-semibold text-foreground-950">
                    {item.title}
                  </span>
                  <span className="mt-0.5 block text-sm text-foreground-600">
                    {item.text}
                  </span>
                </span>
              </li>
            ))}
          </ul>

          <Link
            to="/about"
            className="mt-7 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="h-64 w-full overflow-hidden rounded-lg md:h-[360px]">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20minimal%20navigation%20and%20discovery%20concept%2C%20floating%20rounded%20cards%20and%20soft%20geometric%20shapes%2C%20clean%20bright%20studio%20background%20with%20blue%20and%20orange%20accents%2C%20modern%20editorial%20illustration&width=1000&height=900&seq=nav-intro-portal-01&orientation=squarish"
            alt="蓝导航平台功能示意插画"
            title="蓝导航 综合导航平台功能介绍"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}